import axios from 'axios'
import {LoginActionTypes} from 'store/types/login'
import store from '../../../../config/store'
export const http = () => {
  return axios.create({
    headers: {
      auth_token: localStorage.getItem('auth_token'),
      'Accept-Language': localStorage.getItem('preferredLanguage') === "en" ? 'en_EN' : (localStorage.getItem('preferredLanguage') === "ru" ? 'ru_RU' : 'az_AZ'),
    },
  })
}
export const httpVeryfied = () => {
  const instance =  axios.create({
    headers: {
        auth_token: localStorage.getItem('auth_token_verifyed'),
      'Accept-Language': localStorage.getItem('preferredLanguage') === "en" ? 'en_EN' : (localStorage.getItem('preferredLanguage') === "ru" ? 'ru_RU' : 'az_AZ'),
    },
  })

  
  instance.interceptors.response.use(
    function(response) {
      return response
    },
    function(error) {
      if (error.response.status == 401) {
        localStorage.clear()
        store.dispatch({ type: LoginActionTypes.UNAUTH_USER })
      }
      return Promise.reject(error)
    },
  )
  return instance
}

export const httpWithoutHeader = () => {
  return axios.create({
        headers: {
          'Accept-Language': localStorage.getItem('preferredLanguage') === "en" ? 'en_EN' : (localStorage.getItem('preferredLanguage') === "ru" ? 'ru_RU' : 'az_AZ'),
        },
      })
}

var host = window.location.host
var subdomain = host.split('.')[0]
// 
// export const API_URL=`http://demo.gaiabilgi.com.tr:7030/BReGlobeService/rest/`; // test local

//export const API_URL=`http://demo.gaiabilgi.com.tr:7030/eGlobeService/rest/`;

//export const API_URL= process.env.REACT_API_URL || 'https://newinternetofistest.bankrespublika.az/weblogic/eGlobeService/rest/' // tests

// export const API_URL=`https://newinternetofisdev.bankrespublika.az/weblogic/eGlobeService/rest/`; // dev

export const API_URL=`https://iofis.bankrespublika.az/weblogic/eGlobeService/rest/`; // prod

// export const API_URL=`https://i-ofis.bankrespublika.az/weblogic/eGlobeService/rest/`; // prod

